export const personalData = {
    name: "VIVEK KUMAR JHA",
    title: "Senior Software Engineer | DevOps | Drone Pilot",
    initials: "VJ",
    badges: [
      "🚀Backend Engineer",
      "💼 Freelancer",
      "☁️ DevOps",
      "🚁 Drone Pilot",
      "🤖 AI Engineer"
    ],
    socialLinks: [
      { name: "LinkedIn", icon: "🔗", url: "https://www.linkedin.com/in/vivek-jha1/" },
      { name: "GitHub", icon: "💻", url: "https://github.com/vivekjha1213" },
      { name: "LeetCode", icon: "📊", url: "https://leetcode.com/vivekjha12/" },
      { name: "Medium", icon: "✍️", url: "https://medium.com/@vivekjha1213" },
      { name: "Email", icon: "📧", url: "mailto:vivekjha1213@gmail.com" }
    ],
    aboutParagraphs: [
      "Senior Software Engineer with <span class='text-yellow-400 font-bold'>3+ years</span> of crafting <span class='text-yellow-400 font-bold'>high-performance backend systems</span> in GoLang, Python, and cutting-edge AI technologies.",
      "Specialized in <span class='text-yellow-400 font-bold'>microservices architecture</span>, real-time systems, and <span class='text-yellow-400 font-bold'>DevOps automation</span>. Crushed performance bottlenecks by <span class='text-yellow-400 font-bold'>60%+</span> and scaled systems to handle <span class='text-yellow-400 font-bold'>1M+ daily requests</span>.",
      "<span class='text-yellow-400 font-bold'>Professional Freelancer</span> building custom solutions for Fortune 500s. Led technical teams, mentored junior devs, and architected systems used by <span class='text-yellow-400 font-bold'>500K+ users</span>.",
      "<span class='text-yellow-400 font-bold'>🚁 Certified Drone Pilot</span> combining tech expertise with aerial innovation. Building the future one commit at a time.",
      "<span class='text-yellow-400 font-bold'>🌍 Ready for Global Domination:</span> Actively seeking international opportunities in Dubai, Singapore, Europe. Open to relocation with visa sponsorship. Let's build something epic!"
    ]
  };
  
  export const skillsData = [
    {
      title: "Programming Languages",
      icon: "💻",
      skills: ["GoLang", "Python", "Java", "JavaScript", "C++"]
    },
    {
      title: "Backend & APIs",
      icon: "🔧",
      skills: ["RESTful APIs", "GraphQL", "gRPC", "WebSockets", "Microservices"]
    },
    {
      title: "Databases",
      icon: "🗄️",
      skills: ["PostgreSQL", "MySQL", "MongoDB", "Redis", "DynamoDB"]
    },
    {
      title: "Message Queues",
      icon: "📡",
      skills: ["Apache Kafka", "RabbitMQ", "Event-Driven", "Pub/Sub"]
    },
    {
      title: "Cloud & DevOps",
      icon: "☁️",
      skills: ["AWS", "Docker", "Kubernetes", "CI/CD", "Terraform", "Jenkins"]
    },
    {
      title: "AI/ML & Security",
      icon: "🤖",
      skills: ["LangChain", "OpenAI API", "OAuth 2.0", "JWT", "Compliance"]
    },
    {
      title: "Drone Tech",
      icon: "🚁",
      skills: ["Aerial Photography", "Flight Operations", "Safety Protocols", "Mission Planning"]
    },
    {
      title: "Freelancer",
      icon: "💼",
      skills: ["Project Management", "Client Relations", "Agile/Scrum", "Technical Writing"]
    }
  ];
  
  export const experienceData = [
    {
      company: "Vyturr Tech Innovations",
      role: "Software Engineer (SDE-2)",
      duration: "January 2025 – Present",
      location: "Singapore, Remote",
      responsibilities: [
        "Architected a cross-platform compliance agent in GoLang with native GUI for Windows, Linux, and macOS",
        "Developed within a microservices ecosystem of 14+ services; built and optimized key services in Python",
        "Engineered a real-time chat application using GoLang with WebSocket messaging",
        "Optimized PostgreSQL queries and Redis caching strategies achieving 60% faster performance",
        "Integrated AWS infrastructure for distributed monitoring with auto-scaling and load balancing"
      ]
    },
    {
      company: "Chat360",
      role: "Software Engineer (SDE-1)",
      duration: "October 2023 - January 2025",
      location: "Pune, Maharashtra",
      responsibilities: [
        "Designed high-performance microservices processing 1M+ messages daily with Redis caching and RabbitMQ",
        "Developed AI voice bot integration using GoLang audio sockets and Django Channels",
        "Built email campaign, feedback, and billing systems handling 100,000+ daily emails",
        "Managed production infrastructure serving 500,000+ users with 99.9% uptime"
      ]
    },
    {
      company: "DTROFFLE Pvt Ltd",
      role: "Software Engineer (Backend)",
      duration: "June 2023 - October 2023",
      location: "Gurugram, Haryana",
      responsibilities: [
        "Developed backend services using Django and Django REST Framework",
        "Worked with PostgreSQL, MySQL, and Redis databases",
        "Containerized applications with Docker and deployed on AWS"
      ]
    }
  ];
  
  export const projectsData = [
    {
      name: "Rift Rewind",
      details: [
        "Built an AI-powered League of Legends recap agent analyzing match history",
        "Integrated FastAPI, AWS Bedrock, S3, DynamoDB, and Riot Games API",
        "Implemented multi-region support, caching, and rate limiting",
        "Containerized with Docker and deployed on AWS ECS/Fargate"
      ],
      link: "https://github.com/vivekjha1213/rift-rewind"
    },
    {
      name: "Real-Time Tools & Mentoring",
      details: [
        "Mentored students and working professionals in coding and project development",
        "Built CLI and desktop tools used by large organizations including ISRO",
        "Developed lightweight, real-time solutions for workflow automation"
      ]
    }
  ];
  
  export const educationData = {
    degree: "Bachelor of Technology in Computer Science & Engineering",
    duration: "June 2019 – July 2023",
    institution: "KIIT College of Engineering, Gurugram, Haryana",
    cgpa: "8.22/10",
    specializations: [
      "Data Structures & Algorithms",
      "Software Engineering",
      "Machine Learning",
      "Artificial Intelligence"
    ]
  };